export const WebsiteBrand = Object.freeze({
	SABA: 1,
	CV: 2
});